import React from 'react';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import ContentSave from 'material-ui/svg-icons/content/save';
import ActionInfo from 'material-ui/svg-icons/action/info';
import SocialShare from 'material-ui/svg-icons/social/share';

import NavigationExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenu from 'material-ui/DropDownMenu';
import RaisedButton from 'material-ui/RaisedButton';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import {isPercentage} from '../lib/utils'
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import FontIcon from 'material-ui/FontIcon';
import NavigationArrowDropDownCircle from 'material-ui/svg-icons/navigation/arrow-drop-down-circle';

var numeral = require('numeral');

const styles = {
	SectorCard:{
		margin:10
	},
	cardContentRow:{
	   	display: 'flex',
	    flexDirection: 'row wrap',
		marginLeft:10,
		marginRight:10,
		marginTop:'1%',
		fontSize:14,
		height: 48,
		backgroundColor:'#fff',
	},
	ToolbarGroup:{
		flex:3,
		paddingLeft:15,
		paddingRight:15,
		lineHeight:'48px',

	},
	ToolbarGroupText:{
		flex:2,
		marginLeft:16,
		justifyContent:'initial',
		// paddingRight:15

	},
	ToolbarKeepBtn:{
		flex:5
	},
	ToolbarLabel:{
		flex:3,
		textAlign:'right',
		lineHeight:2,
		fontWeight:600,
		// paddingBottom:29,
		// borderBottom:'1px solid',
	},
	ToolbarLabelNarrow: {
		flex:3,
		textAlign:'right',
		lineHeight:2,
		fontWeight:600,
		maxWidth: 75,
		marginLeft: -25
	},
	IconButton:{
		paddingTop:5
	},
	inputField:{
		width:40,
		fontSize:14,
	},
	loneInputField:{
		width:100,
		fontSize:14,
	},
	infoBtn:{
		// position:'relative',
		// right:30,
		marginLeft:20,
		color:'blue'
	},
	duplicateLink:{
		fontSize:10,
		marginRight: 10,
		color:'#333',
		textAlign:'center',
	},
	duplicateLinkRight:{
		fontSize:10,
		color:'#333',
		textAlign:'center',
		paddingRight: '21px',
	},
	inputPercent:{
		// flex:1,
		// margin:10,
		lineHeight:3,
		textAlign:'left',
		// marginTop: '20px',

	},

	dupIconApply:{
		color:'rgb(6, 111, 28)',
	},
	dupIconRemove:{
		color:'rgb(228, 21, 21)',
	},
	ddIcon:{
		top:0,
	}

};

const iconStyles = {

	color: 'rgb(189, 189, 189)',
	height:36,
	width:36,
	position:'absolute',
	bottom:-2,
	right:22,
};

const strategyFields = [
		{type:'8', name:'Short on Sector'},
		{type:'9', name:'Relative to Sector'},
		{type:'10', name:'Relative to Earning Announcement'},

	]
// const valueTypes = [
// 	{type:'only_min', name:'Only Minimum'},{type:'only_max', name:'Only Maximum'},{type:'both', name:'Range'}
// ]
const posTypes =[
	{type:0, name:'Long'},{type:1, name:'Short'},{type:2, name:'Both'}
]
export default class strategyToolbBar extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			strategy:props.strategy,
			needSave:false,
			errors:{
				vts:"",
				svts:"",
				vt_no_order_before_ea: "",
				vt_alert_before_ea: "",
				vt_close_before_ea: ""
			}

		};
		// console.log("====== strategy")
		// console.log(props)
	};

	// onKeep = () => {
	// 	console.log('onKeep');
	// 	// TODO PASS CALLBACK IN PROPS
	// 	this.props.update(this.state.strategy);
	// };

	onDelete = () =>{

		this.props.delete(this.props.strategy);
	};

	duplicateStrategy = () =>{
		this.props.duplicateStrategy(this.state.strategy);
	};

	removeSimilerStrategies = () => {
		this.props.removeSimilerStrategies(this.state.strategy);
	};

	onChange = (event) => {
		const e = event;
		var newErrors = {
			vts:"",
			svts:"",
			vt_no_order_before_ea: "",
			vt_alert_before_ea: "",
			vt_close_before_ea: ""
		}
		e.preventDefault();
		// console.log('onChange', e.target.value);
		this.props.strategy[e.target.id] = e.target.value
		if(!isPercentage(e.target.value)){

			newErrors = this.state.errors;
			newErrors[e.target.id] = " "


			console.log(this.state.errors)
		}
		this.setState({errors:newErrors})
		this.props.saveStrategy()
		// this.onKeep();

	};

	onFieldSelect = (event, key, payload) => {
		// console.log('onDropDownSelect', key, payload)
		// var strategy = this.state.strategy;

		this.props.strategy.field = payload;
		this.forceUpdate()
		// this.setState({strategy:strategy})
		//console.log(strategy)
		//this.onKeep();

	};
	// onPosTypeSelect = (event, key, payload) => {
	// 	// console.log('onPosTypeSelect', key, payload)
	// 	var strategy = this.state.strategy;
	// 	strategy.pos_type = payload;
	// 	this.setState({strategy:strategy})
	// 	// console.log(this.state.strategy)
	// 	//this.onKeep();
	// };
	render(){
		var fieldNames = strategyFields.map(function(type){
			return <MenuItem key={type.type} id={type.type} value={type.type} primaryText={type.name} />
		});

		var posTypeNames = posTypes.map(function(type){
			return <MenuItem key={type.type} id={type.type} value={type.type} primaryText={type.name} />
		});
		let dDIconNode = <NavigationArrowDropDownCircle/>
		return(

			<Paper zDepth={2}  style={styles.cardContentRow}>
			        <ToolbarGroup className="strat-ddown" style={styles.ToolbarGroup} firstChild={true}>

			            <DropDownMenu iconStyle={styles.ddIcon} iconButton={dDIconNode} value={this.props.strategy.field} onChange={this.onFieldSelect}>
				           {fieldNames}
			            </DropDownMenu>
			        </ToolbarGroup>

							<h5 className={this.props.strategy.field == "10" ? '' : 'hidden'}
								style={Object.assign({}, styles.ToolbarLabelNarrow, {
									marginLeft: -50
								})}>
								No order
							</h5>

							<ToolbarGroup className={this.props.strategy.field == "10" ? '' : 'hidden'}
								style={[styles.ToolbarGroupText, {flex: 8}]} >
								<TextField id="vt_no_order_before_ea" onChange={this.onChange}
									inputStyle={{padding: 6}}
									style={styles.inputField}
									errorText={this.state.errors.vtea}
									value={this.props.strategy.vtea}>
								</TextField>
								<h5 style={styles.inputPercent}>days before EA</h5>
							</ToolbarGroup>

							<h5 className={this.props.strategy.field == "10" ? '' : 'hidden'} style={styles.ToolbarLabelNarrow}>
								Alert
							</h5>

							<ToolbarGroup className={this.props.strategy.field == "10" ? '' : 'hidden'}
								style={[styles.ToolbarGroupText, {flex: 8}]} >
								<TextField id="vt_alert_before_ea" onChange={this.onChange}
									inputStyle={{padding: 6}}
									style={styles.inputField}
									errorText={this.state.errors.vtea}
									value={this.props.strategy.vtea}>
								</TextField>
								<h5 style={styles.inputPercent}>days before EA</h5>
							</ToolbarGroup>

							<h5 className={this.props.strategy.field == "10" ? '' : 'hidden'} style={styles.ToolbarLabelNarrow}>
								Close
							</h5>

							<ToolbarGroup className={this.props.strategy.field == "10" ? '' : 'hidden'}
								style={[styles.ToolbarGroupText, {flex: 8}]} >
								<TextField id="vt_close_before_ea" onChange={this.onChange}
									inputStyle={{padding: 6}}
									style={styles.inputField}
									errorText={this.state.errors.vtea}
									value={this.props.strategy.vtea}>
								</TextField>
								<h5 style={Object.assign({}, styles.inputPercent, {
										marginRight: 18
									})}>days before EA</h5>
							</ToolbarGroup>

		        	<h5  className={this.props.strategy.field == "8" ? '' : 'hidden'} style={styles.ToolbarLabel}>
		        		Short entry trigger:
		        	</h5>
			        <ToolbarGroup className={this.props.strategy.field == "8" ? '' : 'hidden'} style={styles.ToolbarGroupText} >

			        	<TextField id="vts" onChange={this.onChange} style={styles.inputField}
				        	errorText={this.state.errors.vts}
				        	value={this.props.strategy.vts}>
			        	</TextField>
			        	<h5 style={styles.inputPercent}>%</h5>
			        </ToolbarGroup>
		         	<h5  className={this.props.strategy.field == "8" ? '' : 'hidden'} style={styles.ToolbarLabel}>
		        		Stop loss on short:
		        	</h5>
			        <ToolbarGroup className={this.props.strategy.field == "8" ? '' : 'hidden'} style={styles.ToolbarGroupText} >

			        	<TextField id="svts" onChange={this.onChange} style={styles.inputField}

			        	errorText={this.state.errors.svts}
			        	value={this.props.strategy.svts}>
			        	</TextField>
			        	<h5 style={styles.inputPercent}>%</h5>
			        </ToolbarGroup>
			        <h5  className={this.props.strategy.field == "9" ? '' : 'hidden'} style={styles.ToolbarLabel}>
		        		Relative to Sector:
		        	</h5>
			        <ToolbarGroup className={this.props.strategy.field == "9" ? '' : 'hidden'} style={styles.ToolbarGroupText} >

			        	<TextField id="rel_to_sec" onChange={this.onChange} style={styles.loneInputField}

			        	// errorText={this.state.errors.svts}
			        	value={this.props.strategy.rel_to_sec}>
			        	</TextField>
			        	<h5 style={styles.inputPercent}>%</h5>
			        </ToolbarGroup>



			        <ToolbarGroup style={styles.ToolbarKeepBtn}  >
						<a style={styles.duplicateLink} onClick={this.duplicateStrategy} >
							{/*<FontIcon className="icon-apply-all" style={styles.dupIconApply}/>*/}
							<i className="material-icons" style={styles.dupIconApply}>check</i>
							<br/>
							Apply to all
						</a>
						<a style={styles.duplicateLinkRight} onClick={this.removeSimilerStrategies} >
							{/*<FontIcon className="icon-reset-all" style={styles.dupIconRemove}/>*/}
							<i className="material-icons" style={styles.dupIconRemove}>close</i>
							<br/>
							Remove from all
						</a>
						<IconButton iconStyle={iconStyles}  onClick={this.onDelete} >
							<i className="material-icons">close</i>
						</IconButton>
					</ToolbarGroup>
			</Paper>);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/StrategyToolBar.js